/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { Page } from '../types';
// @ts-ignore
import type { UpdatePageLayoutBodyInner } from '../types';
/**
 * PagesApi - axios parameter creator
 * @export
 */
export const PagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a page.
         * @summary Delete an existing Page
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePage: async (pageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('deletePage', 'pageId', pageId)
            const localVarPath = `/pages/{page_id}`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a page.
         * @summary Find Page by ID
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage: async (pageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('getPage', 'pageId', pageId)
            const localVarPath = `/pages/{page_id}`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest published version of a page for a dashboard
         * @summary Find page for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageForPublishedDashboard: async (dashboardId: string, pageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPageForPublishedDashboard', 'dashboardId', dashboardId)
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('getPageForPublishedDashboard', 'pageId', pageId)
            const localVarPath = `/published/dashboards/{dashboard_id}/pages/{page_id}`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"page_id"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the position and dimensions of all widget containers for a page.
         * @summary Update Page layout
         * @param {string} pageId 
         * @param {Array<UpdatePageLayoutBodyInner>} [updatePageLayoutBodyInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageLayout: async (pageId: string, updatePageLayoutBodyInner?: Array<UpdatePageLayoutBodyInner>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('updatePageLayout', 'pageId', pageId)
            const localVarPath = `/pages/{page_id}/layout`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePageLayoutBodyInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PagesApi - functional programming interface
 * @export
 */
export const PagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a page.
         * @summary Delete an existing Page
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePage(pageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePage(pageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PagesApi.deletePage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a page.
         * @summary Find Page by ID
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPage(pageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Page>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPage(pageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PagesApi.getPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the latest published version of a page for a dashboard
         * @summary Find page for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageForPublishedDashboard(dashboardId: string, pageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Page>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPageForPublishedDashboard(dashboardId, pageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PagesApi.getPageForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the position and dimensions of all widget containers for a page.
         * @summary Update Page layout
         * @param {string} pageId 
         * @param {Array<UpdatePageLayoutBodyInner>} [updatePageLayoutBodyInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePageLayout(pageId: string, updatePageLayoutBodyInner?: Array<UpdatePageLayoutBodyInner>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePageLayout(pageId, updatePageLayoutBodyInner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PagesApi.updatePageLayout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PagesApi - factory interface
 * @export
 */
export const PagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PagesApiFp(configuration)
    return {
        /**
         * Deletes a page.
         * @summary Delete an existing Page
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePage(pageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePage(pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a page.
         * @summary Find Page by ID
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage(pageId: string, options?: RawAxiosRequestConfig): AxiosPromise<Page> {
            return localVarFp.getPage(pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest published version of a page for a dashboard
         * @summary Find page for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageForPublishedDashboard(dashboardId: string, pageId: string, options?: RawAxiosRequestConfig): AxiosPromise<Page> {
            return localVarFp.getPageForPublishedDashboard(dashboardId, pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the position and dimensions of all widget containers for a page.
         * @summary Update Page layout
         * @param {string} pageId 
         * @param {Array<UpdatePageLayoutBodyInner>} [updatePageLayoutBodyInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageLayout(pageId: string, updatePageLayoutBodyInner?: Array<UpdatePageLayoutBodyInner>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePageLayout(pageId, updatePageLayoutBodyInner, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PagesApi - object-oriented interface
 * @export
 * @class PagesApi
 * @extends {BaseAPI}
 */
export class PagesApi extends BaseAPI {
    /**
     * Deletes a page.
     * @summary Delete an existing Page
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PagesApi
     */
    public deletePage(pageId: string, options?: RawAxiosRequestConfig) {
        return PagesApiFp(this.configuration).deletePage(pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a page.
     * @summary Find Page by ID
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PagesApi
     */
    public getPage(pageId: string, options?: RawAxiosRequestConfig) {
        return PagesApiFp(this.configuration).getPage(pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest published version of a page for a dashboard
     * @summary Find page for published dashboard by ID
     * @param {string} dashboardId 
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PagesApi
     */
    public getPageForPublishedDashboard(dashboardId: string, pageId: string, options?: RawAxiosRequestConfig) {
        return PagesApiFp(this.configuration).getPageForPublishedDashboard(dashboardId, pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the position and dimensions of all widget containers for a page.
     * @summary Update Page layout
     * @param {string} pageId 
     * @param {Array<UpdatePageLayoutBodyInner>} [updatePageLayoutBodyInner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PagesApi
     */
    public updatePageLayout(pageId: string, updatePageLayoutBodyInner?: Array<UpdatePageLayoutBodyInner>, options?: RawAxiosRequestConfig) {
        return PagesApiFp(this.configuration).updatePageLayout(pageId, updatePageLayoutBodyInner, options).then((request) => request(this.axios, this.basePath));
    }
}

